import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "StudyYear",
    isNumber: true,
    isSum: true,
  },
];

export const VillageToAnnualScreeningCount = {
  label: "鄉鎮",
  key: "VillageToAnnualScreeningCount",
  path: "ElderlyHealthCheckup/VillageToAnnualScreeningCount",
  api: "TCS_V_OldStudyList01V",
  render: (options) => (
    <Diagram.ElderlyHealthCheckup.VillageToAnnualScreeningCount {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "Region",
      field: "Region",
      header: "",
      isSkip: true,
    },
  ],
  levelColumns,
  columns: [],
};
